export default __webpack_public_path__ + "static/media/Calendar-gold.54a328be.svg";